import React from "react";

const ShimmerVideoFeed = () => {
  return (
    <div className="shimmer-wrapperV ">
      <div className="shimmerV"></div>
    </div>
  );
};

export default ShimmerVideoFeed;
